import React from "react";
import { MdSimCardDownload } from "react-icons/md";
import { Typewriter } from "react-simple-typewriter";

const Banner = () => {
  const bannerStyle = {
    width: "100%",
    height: "100vh",
  };

  return (
    <div style={bannerStyle}>
      <div className="flex flex-col items-center justify-center h-[100vh]">
        <h1 className="font-bold text-base-100 lg:text-4xl">WELCOME </h1>
        <h1 className="font-bold text-primary mt-5 lg:text-2xl text-center bg-secondary">
          {" "}
          <Typewriter
            words={["I'M HABIBULLAH NOMANI"]}
            loop={0}
            cursor
            cursorStyle="|"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1000}
          ></Typewriter>
        </h1>

        <h1 className="font-bold text-primary mt-5 lg:text-xl text-center bg-secondary">
          {" "}
          <Typewriter
            words={["A Passionate Frontend Developer From Bangladesh"]}
            loop={0}
            cursor
            cursorStyle="|"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1000}
          ></Typewriter>
        </h1>

        <p className="lg:text-xl  text-white p-5 text-justify lg:w-1/2 mt-5">
          I'm a Frontend Developer who's excited to contribute to company growth
          with innovative skills. I'm self-motivated and always eager to learn
          and adapt to new technologies.
        </p>

        <a
          href="https://drive.google.com/file/d/1yCT_CY8rMjibv5XXFL5vdrMmEz6pWfDC/view?usp=sharing"
          target="blank"
          download
          className="btn btn-sm btn-primary px-5  mt-5"
        >
          <MdSimCardDownload className="mr-2 text-xl" />
          Download Resume
        </a>
      </div>
    </div>
  );
};

export default Banner;
